// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__1X9nI","alert__content":"Alert_alert__content__qQM6k","error":"Alert_error__hSm7C","close-btn":"Alert_close-btn__8cfOR"};